<body class="wwef">
  <div class="wwef-container">
    <h3 class="page-title">{{ CONST.HEADER }}</h3>
    <ion-row>
      <ion-col size="12">
        @if (isFormSubmitted(); as submitted) {
          @if (submitted && form.get("weight")?.errors?.maxError) {
            <span class="error-message">
              {{
                CONST.WEIGHT_ERROR.replace(
                  "%max",
                  form.get("weight")?.errors?.maxError.max +
                    unitConfig.weight.charAt(0).toUpperCase() +
                    unitConfig.weight.slice(1).toLowerCase()
                )
              }}
            </span>
          }
        }
      </ion-col>
      <ion-col size="7">
        <app-add-new-scan
          [form]="form"
          [isFormSubmitted]="isFormSubmitted()"
          [hasFileUpload]="false"
          [hasButton]="false"
          [fileType]="PARSE_TYPE.TRACKINGNUMBER_ONLY"
        >
          <form [formGroup]="form">
            <ion-row>
              <ion-col size="auto">
                <div class="country-list-dropdown-container">
                  <app-form-select
                    [label]="CONST.DESTINATION_CC"
                    [options]="countryList()"
                    [placeholder]="CONST.SELECT_COUNTRY"
                    [hasRequiredSign]="true"
                    [hasAltHeight]="true"
                    formControlName="destination"
                  >
                  </app-form-select>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="auto">
                <app-form-input-field
                  class="input-field"
                  [label]="CONST.LENGTH"
                  [regexType]="SpecialCharacters.SPECIAL_WITH_PERIOD"
                  [suffix]="unitConfig['length']"
                  formControlName="length"
                  [required]="true"
                  [maxLength]="5"
                ></app-form-input-field>
              </ion-col>
              <ion-col size="auto">
                <app-form-input-field
                  class="input-field"
                  [label]="CONST.WIDTH"
                  [regexType]="SpecialCharacters.SPECIAL_WITH_PERIOD"
                  [suffix]="unitConfig['width']"
                  formControlName="width"
                  [required]="true"
                  [maxLength]="5"
                ></app-form-input-field>
              </ion-col>
              <ion-col size="auto">
                <app-form-input-field
                  class="input-field"
                  [label]="CONST.HEIGHT"
                  [regexType]="SpecialCharacters.SPECIAL_WITH_PERIOD"
                  [suffix]="unitConfig['height']"
                  formControlName="height"
                  [required]="true"
                  [maxLength]="5"
                ></app-form-input-field>
              </ion-col>
              <ion-col size="auto">
                <app-form-input-field
                  class="input-field weight-input"
                  [label]="CONST.WEIGHT"
                  [regexType]="SpecialCharacters.NUMBER_ONLY"
                  [required]="true"
                  formControlName="weight"
                  (keyup.dot)="lbInput.focus()"
                  [maxLength]="4"
                ></app-form-input-field>
              </ion-col>
              <ion-col
                size="auto"
                class="decimal-separator-col"
                [ngClass]="{
                  'has-error':
                    (form.get('length')?.dirty &&
                      form.get('length')?.invalid) ||
                    (form.get('width')?.dirty && form.get('width')?.invalid) ||
                    (form.get('height')?.dirty &&
                      form.get('height')?.invalid) ||
                    (form.get('weight')?.dirty && form.get('weight')?.invalid),
                }"
              >
                <div class="decimal-separator">.</div>
              </ion-col>
              <ion-col size="auto">
                <app-form-input-field
                  #lbInput
                  class="input-field lb-input"
                  [label]="'  '"
                  [regexType]="SpecialCharacters.NUMBER_ONLY"
                  [suffix]="unitConfig['weight']"
                  formControlName="lb"
                  [maxLength]="1"
                  [hasRequiredSign]="false"
                ></app-form-input-field>
              </ion-col>
              <ion-col size="auto" class="submit-button">
                <ion-button
                  class="submit-btn"
                  [disabled]="form.invalid"
                  (click)="submit()"
                >
                  {{ CONST.SUBMIT }}
                </ion-button>
              </ion-col>
            </ion-row>
          </form>
        </app-add-new-scan>
      </ion-col>
      <!-- Icons -->
      @if (dataSource.data.length > 0) {
        <ion-col size="5" class="top-icons ion-no-padding action-btn-column">
          <app-filter-icon
            [isDisabled]="!isFilterEnabled"
            (clearFilterEvent)="clearAllFilters()"
          >
          </app-filter-icon>
        </ion-col>
      }
    </ion-row>

    <!-- Table -->
    @if (dataSource.data.length > 0) {
      <div class="wwef-table-container">
        <table mat-table [dataSource]="dataSource" class="wwef-table">
          <!-- Tracking Numbers -->
          <ng-container matColumnDef="trackingNumber">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="trackingNumber-headers"
              class="tracking-number-column-header"
            >
              <app-table-search-component
                [columnName]="COLUMNTEXT.TRACKING_NUMBER"
                [control]="trackingNumber.formControl"
                [maxLength]="18"
                [textInputWidth]="153"
                [searchIconOffset]="82"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>

            <td
              headers="tracking-number-header"
              class="selectable cursor-pointer tracking-number-link tracking-number-data-column"
              mat-cell
              *matCellDef="let wwefRow; let i = index"
            >
              <app-table-tracking-number-cell
                [trackingNumber]="wwefRow.trackingNumber"
              ></app-table-tracking-number-cell>
            </td>
          </ng-container>

          <!-- Sort Date -->
          <ng-container matColumnDef="sortDate">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="sortDate-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{ COLUMNTEXT.SORT_DATE }}</ion-row>
              <div class="sort-date-picker-container date-picker-container">
                <app-form-date-picker
                  [icon]="SRC.CALENDAR"
                  [placeholder]="CONST.SELECT_DATE"
                  [formControl]="sortDate.formControl"
                  [minDate]="tableMinSortDate"
                  [maxDate]="tableMaxSortDate"
                  [enabledDates]="enabledDates"
                  (valueChange)="search()"
                ></app-form-date-picker>
              </div>
            </th>

            <td
              headers="sort-date-header"
              mat-cell
              *matCellDef="let wwefRow; let i = index"
            >
              {{ wwefRow.sortDate }}
            </td>
          </ng-container>

          <!-- Sort Code -->
          <ng-container matColumnDef="sortCode">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="sortCode-headers"
              class="sortCode-header-container"
            >
              <app-table-header-dropdown
                [columnText]="COLUMNTEXT.SORT_CODE"
                [itemId]="sortCode.itemId"
                [searchResults]="sortCodeOption"
                [resetData]="resetSelectDropdowns"
                [showDropdown]="dropdownOpen[0]"
                (dropdownChange)="
                  dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
                "
                (checkboxesUpdated)="
                  onStatusChangeForDropdowns($event, sortCode)
                "
                [popoverStyle]="{ maxWidth: 100, offsetX: -65 }"
              >
              </app-table-header-dropdown>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="sort-code-header"
            >
              {{ wwefRow.sortCode }}
            </td>
          </ng-container>

          <!-- Destination CC -->
          <ng-container matColumnDef="destinationCC">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="destinationCC-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{ COLUMNTEXT.DESTINATION_CC }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="destinationCC-column-header"
            >
              {{ wwefRow.destination }}
            </td>
          </ng-container>

          <!-- Length -->
          <ng-container matColumnDef="length">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="length-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.LENGTH.replace("%unit", unitConfig["length"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="length-column-header"
            >
              {{ wwefRow.length }}
            </td>
          </ng-container>

          <!-- Width -->
          <ng-container matColumnDef="width">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="width-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.WIDTH.replace("%unit", unitConfig["width"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="width-column-header"
            >
              {{ wwefRow.width }}
            </td>
          </ng-container>

          <!-- Height -->
          <ng-container matColumnDef="height">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="height-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.HEIGHT.replace("%unit", unitConfig["height"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="height-column-header"
            >
              {{ wwefRow.height }}
            </td>
          </ng-container>

          <!-- Weight -->
          <ng-container matColumnDef="weight">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="weight-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{
                COLUMNTEXT.WEIGHT_LB.replace("%unit", unitConfig["weight"])
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="weight-column-header"
            >
              {{ wwefRow.weight }}
            </td>
          </ng-container>

          <!-- UOW Type -->
          <ng-container matColumnDef="uowType">
            <th
              mat-header-cell
              *matHeaderCellDef
              id="uow-headers"
              class="sort-date-header"
            >
              <ion-row class="th-text">{{ COLUMNTEXT.UOW_TYPE }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container height-40"
              ></div>
            </th>

            <td
              mat-cell
              *matCellDef="let wwefRow; let i = index"
              headers="uow-type-header"
            >
              {{ wwefRow.uowType }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-border no-results"
              [attr.colspan]="displayedColumns.length"
            >
              <app-no-results-found></app-no-results-found>
            </td>
          </tr>
        </table>
      </div>
    }
  </div>
</body>
